import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const TNC = () => {
  return (
    <div
      style={{ paddingBottom: "150px", background: "#000", paddingTop: "50px" }}
    >
      <div className="how_to" style={{ paddingTop: "100px" }}>
        <Container>
          <Row className="row sk__featureboxes">
            <Col className="col text-center sk__heading-spacer-s">
              <div className="cover-text-wrapper" style={{ zIndex: 10 }}>
                <div
                  className="fancy-gradient-text-box"
                  style={{ transform: "translate(0px, 0px)", opacity: 1 }}
                >
                  <h1 className="super-heading sk__gradient-fancy-text mb-2 mb-sm-0 mb-xxl-2 make_small_mobile">
                    Terms & Conditions
                  </h1>
                  <span className="super-heading sk__gradient-fancy-text-back mb-2 mb-sm-0 mb-xxl-2 make_small_mobile">
                    {" "}
                    Terms & Conditions
                  </span>
                </div>
              </div>
              <h2
                className="h2-large sk__fade-in-6"
                data-sk-fade-match={3}
                style={{ opacity: 1 }}
              >
                {/* Last Updated: Aug 24, 2024 */}
              </h2>
            </Col>
          </Row>

          <Row
            className="justify-content-center"
            style={{ color: "#fff", lineHeight: "30px" }}
          >
            <Col lg={8}>
              <article className="text-justify">
                <p>
                  Please read these Terms and Conditions carefully before
                  proceeding with the signup and registration process. These
                  Terms and Conditions govern your access to and use of the
                  FTtunes website (the “Site”) and any content, information,
                  products and/or services provided on or through the Site
                  (collectively referred to as the “Services”).
                </p>

                <div style={{ position: "relative" }}>
                  <img
                    src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAKwAtwMBIgACEQEDEQH/xAAbAAADAQEBAQEAAAAAAAAAAAAAAgMBBAYFB//EAB4QAQEBAQEBAAIDAAAAAAAAAAACARESAxNxBDFR/8QAGwEAAwEBAQEBAAAAAAAAAAAAAQIDAAUEBwb/xAAaEQEBAQEBAQEAAAAAAAAAAAAAAQIREhMD/9oADAMBAAIRAxEAPwD89yT5J8k2S+iTD9BMEyW5J+N4pMnmS8HD8bwfJvJODh+Dg+R4Xg4bjeDxuE4OH4ONxuE43huDg8bhW8NxvB4PGcHDcHDcNxnG8bw2T6/oeDwnBxafjVK5/G/YdkC2OXgdmfxpAe8h6j5mYbhuAsyHGcHG8bweDxnA0cHgsBuDg8bhQbgbjcKOGDcbjOBvG8HjcZwcMODweAZPf6PHz2v06fn8i3UgXUiXz+P+umPkpHzXiEdfojraM/JWfkvMKT80btK7c+fJjsz5gn0J7eV4DcHHQ46HGBoHjMDQ3GYG8HGbjA3g4zcYGt4zcZwGyKVj4hbIFsiMztL/AD+SsfNeIT1tPW04+a8QeYWmENbR1osQrMGiFohHWkroswrMHmFZhG6Tuk8gOmYBPROvEb86Ls679+adfN15t1Jtxt46fxjPmPsfbm863xrqyG+G9h7cufOm/idXhvgPYe3J+Jv4nV4HgPbe3NnyNPzdGQbIC7C7Sn5qzB8hSYTuk7okwrEHmFZhPWk7osyrMGmFphHWkrSzC0QaIWmEdaTtJMKzB5hWYSuiWkmAvMhP0TryOwnsO2oSqHVmnQmnLsM8OjYZ4N6N6R8jyt5bkt6b0j5b5W8jyHoPSPlvlbyPLeg9JeTZCmSbJC6C6TyFJk+SpMkui2kmVphsytMpa0naWIWiGzK8QlrSdpYhaINELRCGtJ2lmFZg8wpMpXRbU8gOjIBPRevJ1CVQ7ahKodOaeyVybBfLpqCbKk0eaQ8t8q+R5H03pLy3yp5b5brdS8t8qeW5IdbqeSfJPkmyQui2kmVJg8ypMp3RbSzKsS2YWiE7olrIheJEytEo60naIlaJEStMoa0S1kyrMtmVZlK6LaTJC+SCei9eWuEah31CNw6WdPVK4qkmy6qhOpVmjyufyzytss8n6PU/I8qcHG63U/Jsk/luSHW6TJPknzDZJbS2syVJlsyrMp3RbWTK0y2ZViUtaJaJhaZEytMo60S0RK0yIlaZR1olpZlSZNMqZKV0XpckKZgL0HnqhG4d1QjcPfnS8rhqEqh2XCVStnR5XJsl8umpJsqTR+o8HFPI8j1ukzG5J8k2SFrdJkqTJplSZLdFtLMqzLZlWZSuiWiZVmWzKsylrRbRMrTImVplHWiWiJVmRMqziNpGZJ8xuSfJTtAuSFMwB1uvjVCNw7qlG4evOlJXBcI1DuuEahbOjyuOpT2XVUp1K00eVz+WeVtlnDdHqeSbJPkmyQtbpclSZbkqTJLS2smVpkTKsyndFtESvMliV5lHVJaJlWZEyrMo2lE4pMtmT5idpRmGyTZhsxO0C8B+AOs+dUo3Ds2Uql6JoziuELl3XKFwtnR5XFUpVLrqEqlaaPK5dlnF9kvlSaHqWYfJNkmyWtbrJlSZbMqTKdodEytMsmVplK0lomVplkyrMpapa2cVmWTKsylaUTKmYMw+YlaDMw2Y3MNmFtAvAbgDrOTZTuXRqdYrKPXLUo3LqrEqxXOjOOoRuXZeI3i+dGlctSTZXrCbik0fqfk2Ybjcwet0TKs4ycVnE7S2tmVZlkqylqlpplWZZKspWlbOKZgk+JWgMw+YMNhLSjMbmGxpesTgMGZ//9k="
                    alt="VRE"
                    class=" blur-1"
                    style={{
                      position: "absolute",
                      top: "0px",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  ></img>
                </div>

                <p>
                  This legal agreement is established between you (the “User”)
                  and FTtunes. By accessing or using the Site and Services, you
                  agree to adhere to these Terms and Conditions. FTtunes
                  reserves the right to modify, suspend or terminate the Site
                  and Services at any time and to revise these Terms of Service
                  without prior notice. You are responsible for periodically
                  reviewing these Terms of Service for any updates or changes.
                  Continued use of the Site and/or Services after any
                  modifications are posted constitutes your acceptance of the
                  updated Terms. You may not amend or modify these Terms without
                  the express written consent of FTtunes.
                </p>

                <p>
                  NOTE: BY USING THE FTtunes SITE OR SERVICES, YOU AUTOMATICALLY
                  AGREE TO THESE TERMS. IF YOU DO NOT ACCEPT THESE TERMS IN
                  FULL, YOU SHOULD NOT ACCESS OR USE THE SITE OR SERVICES.
                </p>

                <ol>
                  <li>
                    <strong>Use Of The Site</strong>
                  </li>
                </ol>

                <ul>
                  <li>
                    <strong>Eligibility</strong>
                  </li>
                </ul>

                <p>
                  FTtunes provides access to the Site for individuals who can
                  legally enter into binding contracts under applicable law. The
                  Site is designed for users who are 18 years of age or older.
                  If you are at least 13 years old, you may use the Site only
                  under the supervision of a parent or legal guardian who agrees
                  to be bound by these Terms. FTtunes discourages children under
                  13 from using the Site.
                </p>

                <ul>
                  <li>
                    <strong>
                      Compliance With Terms Of Services and Applicable Law
                    </strong>
                  </li>
                </ul>

                <p>
                  By signing up and using the FTtunes website, you agree to
                  comply with these Terms, all applicable contractual
                  agreements, privacy policies and all relevant laws, rules and
                  regulations.
                </p>

                <ul>
                  <li>
                    <strong>Third-Party Services</strong>
                  </li>
                </ul>

                <p>
                  FTtunes may collaborate with third-party service providers to
                  offer certain features or services accessible through the
                  Site. FTtunes does not control these third parties and is not
                  responsible for their actions or services. By using these
                  third-party services, you agree that FTtunes is not liable for
                  any issues that may arise. These third parties may have their
                  own terms of use and policies that you must adhere to.
                </p>

                <ol start="2">
                  <li>
                    <strong>Rules For Using The Site</strong>
                  </li>
                </ol>

                <p>Prohibited Use</p>
                <p>You agree not to:</p>

                <ul>
                  <li>
                    Interfere with the operation of the FTtunes Site or use any
                    software, malware or technology designed to disrupt or
                    damage the Site’s infrastructure.
                  </li>
                  <li>
                    Modify, create derivative works from, reverse engineer,
                    decompile or disassemble any technology used by FTtunes.
                  </li>
                  <li>
                    Use automated tools such as robots, spiders or other devices
                    to monitor activity on or copy pages from the Site, except
                    for standard search engine operations.
                  </li>
                  <li>
                    Collect personal information or data from other users
                    without their consent.
                  </li>
                  <li>
                    Use meta tags, search terms or keywords containing FTtunes's
                    name or trademarks without authorization.
                  </li>
                  <li>
                    Encourage or participate in any activities that disrupt
                    another user’s experience on the Site.
                  </li>
                </ul>

                <p>
                  <strong>A. Submission</strong>
                </p>

                <p>
                  By submitting any content, ideas, suggestions or other
                  information to FTtunes, you grant FTtunes the right to use
                  these Submissions for marketing and promotional purposes.
                  FTtunes is under no obligation to keep your Submissions
                  confidential and you waive any claims against FTtunes
                  regarding moral rights or other legal rights related to the
                  use of your Submissions.
                </p>

                {/* <p>
                  You agree that FTtunes will have no obligation to keep any
                  Submissions confidential in this case. And, you will not bring
                  a claim against FTtunes based on “moral rights” or the like
                  arising from FTtunes’s use of a Submission.
                </p> */}

                <p>
                  <strong>B. Representation and Warranties</strong>
                </p>

                <p>
                  You represent and warrant that your use of the FTtunes Site
                  will not violate the intellectual property rights, privacy
                  rights or other legal rights of any third party and that you
                  will comply with all applicable laws and regulations.
                </p>

                <ol start="3">
                  <li>
                    <strong>Disclaimers, Exclusions and Limitations</strong>
                  </li>
                </ol>

                <p>
                  <strong>A. Disclaimer of Warranties</strong>
                </p>

                <div style={{ position: "relative" }}>
                  <img
                    src="data:image/jpeg;base64,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"
                    alt="VRE"
                    class=" blur-1"
                    style={{
                      position: "absolute",
                      top: "0px",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  ></img>
                </div>

                <p>
                  FTtunes provides the Site and Services on an "as is" and "as
                  available" basis. FTtunes does not guarantee that the Site
                  will be error-free, uninterrupted or compatible with your
                  hardware or software configurations.
                </p>

                <p>
                  <strong>B. Exclusion of Damages</strong>
                </p>

                <p>
                  FTtunes shall not be liable for any consequential, incidental,
                  indirect, punitive or special damages, including but not
                  limited to lost profits, lost data or loss of goodwill,
                  arising from your use of the Site.
                </p>

                <p>
                  <strong>C. Limitation of Liability</strong>
                </p>

                <p>
                  Except for breaches of representations or warranties,
                  FTtunes's liability under these Terms shall not exceed the
                  greater of the amount paid by FTtunes to you during the six
                  months preceding the event or $100.
                </p>

                <ol start="4">
                  <li>
                    <strong>Indemnification</strong>
                  </li>
                </ol>

                <p>
                  You agree to indemnify and hold FTtunes and its affiliates,
                  employees and representatives harmless from any claims,
                  damages or expenses, including legal fees, arising from your
                  breach of these Terms. FTtunes reserves the right to manage
                  the defense and settlement of any claim at your expense.
                </p>

                {/* <p>
                  If you have to indemnify FTtunes under this Section, FTtunes
                  will have the right to control the defence, settlement, and
                  resolution of any Claim at your sole expense. You may not
                  settle or otherwise resolve any Claim without FTtunes’s
                  express written permission.
                </p> */}

                <ol start="5">
                  <li>
                    <strong>Termination</strong>
                  </li>
                </ol>

                {/* <p>
                  <strong>Termination</strong>
                </p> */}

                <p>
                  FTtunes reserves the right to suspend or terminate your access
                  to the Site if you breach these Terms. Upon termination,
                  FTtunes may delete any of your Submissions or related content
                  from its servers without liability.
                </p>

                <p>
                  <strong>Survival</strong>
                </p>

                <p>
                  The provisions of these Terms will remain in effect after
                  termination.
                </p>

                <p>
                  <strong>Effect of Termination</strong>
                </p>

                <p>
                  You may terminate your FTtunes account at any time. Likewise,
                  FTtunes may close your account for any reason. Upon
                  termination, FTtunes may delete any of your content without
                  notice or liability.
                </p>

                <p>
                  <strong>Notices</strong>
                </p>

                {/* <p>
                  All notices required or permitted to be given under these
                  terms of services will be in writing and delivered to the
                  other party by any of the following methods: (i) mail, (ii)
                  overnight courier, or (iii) email.
                </p> */}

                <p>
                  All notices required under these Terms must be in writing and
                  delivered by mail, courier or email to the following address:
                </p>

                <div style={{ position: "relative" }}>
                  <img
                    src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAKwAtwMBIgACEQEDEQH/xAAbAAADAQEBAQEAAAAAAAAAAAAAAgMBBAYFB//EAB4QAQEBAQEBAAIDAAAAAAAAAAACARESAxNxBDFR/8QAGwEAAwEBAQEBAAAAAAAAAAAAAQIDAAUEBwb/xAAaEQEBAQEBAQEAAAAAAAAAAAAAAQIREhMD/9oADAMBAAIRAxEAPwD89yT5J8k2S+iTD9BMEyW5J+N4pMnmS8HD8bwfJvJODh+Dg+R4Xg4bjeDxuE4OH4ONxuE43huDg8bhW8NxvB4PGcHDcHDcNxnG8bw2T6/oeDwnBxafjVK5/G/YdkC2OXgdmfxpAe8h6j5mYbhuAsyHGcHG8bweDxnA0cHgsBuDg8bhQbgbjcKOGDcbjOBvG8HjcZwcMODweAZPf6PHz2v06fn8i3UgXUiXz+P+umPkpHzXiEdfojraM/JWfkvMKT80btK7c+fJjsz5gn0J7eV4DcHHQ46HGBoHjMDQ3GYG8HGbjA3g4zcYGt4zcZwGyKVj4hbIFsiMztL/AD+SsfNeIT1tPW04+a8QeYWmENbR1osQrMGiFohHWkroswrMHmFZhG6Tuk8gOmYBPROvEb86Ls679+adfN15t1Jtxt46fxjPmPsfbm863xrqyG+G9h7cufOm/idXhvgPYe3J+Jv4nV4HgPbe3NnyNPzdGQbIC7C7Sn5qzB8hSYTuk7okwrEHmFZhPWk7osyrMGmFphHWkrSzC0QaIWmEdaTtJMKzB5hWYSuiWkmAvMhP0TryOwnsO2oSqHVmnQmnLsM8OjYZ4N6N6R8jyt5bkt6b0j5b5W8jyHoPSPlvlbyPLeg9JeTZCmSbJC6C6TyFJk+SpMkui2kmVphsytMpa0naWIWiGzK8QlrSdpYhaINELRCGtJ2lmFZg8wpMpXRbU8gOjIBPRevJ1CVQ7ahKodOaeyVybBfLpqCbKk0eaQ8t8q+R5H03pLy3yp5b5brdS8t8qeW5IdbqeSfJPkmyQui2kmVJg8ypMp3RbSzKsS2YWiE7olrIheJEytEo60naIlaJEStMoa0S1kyrMtmVZlK6LaTJC+SCei9eWuEah31CNw6WdPVK4qkmy6qhOpVmjyufyzytss8n6PU/I8qcHG63U/Jsk/luSHW6TJPknzDZJbS2syVJlsyrMp3RbWTK0y2ZViUtaJaJhaZEytMo60S0RK0yIlaZR1olpZlSZNMqZKV0XpckKZgL0HnqhG4d1QjcPfnS8rhqEqh2XCVStnR5XJsl8umpJsqTR+o8HFPI8j1ukzG5J8k2SFrdJkqTJplSZLdFtLMqzLZlWZSuiWiZVmWzKsylrRbRMrTImVplHWiWiJVmRMqziNpGZJ8xuSfJTtAuSFMwB1uvjVCNw7qlG4evOlJXBcI1DuuEahbOjyuOpT2XVUp1K00eVz+WeVtlnDdHqeSbJPkmyQtbpclSZbkqTJLS2smVpkTKsyndFtESvMliV5lHVJaJlWZEyrMo2lE4pMtmT5idpRmGyTZhsxO0C8B+AOs+dUo3Ds2Uql6JoziuELl3XKFwtnR5XFUpVLrqEqlaaPK5dlnF9kvlSaHqWYfJNkmyWtbrJlSZbMqTKdodEytMsmVplK0lomVplkyrMpapa2cVmWTKsylaUTKmYMw+YlaDMw2Y3MNmFtAvAbgDrOTZTuXRqdYrKPXLUo3LqrEqxXOjOOoRuXZeI3i+dGlctSTZXrCbik0fqfk2Ybjcwet0TKs4ycVnE7S2tmVZlkqylqlpplWZZKspWlbOKZgk+JWgMw+YMNhLSjMbmGxpesTgMGZ//9k="
                    alt="VRE"
                    class=" blur-1"
                    style={{
                      position: "absolute",
                      top: "0px",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  ></img>
                </div>

                {/* <p>
                  Dubai-Head Office
                  <br />
                  J2701 Blue Matrix Centre
                  <br />
                  Prime Tower, Business Bay
                  <br />
                  Dubai, UAE
                </p> */}

                <p>
                  India
                  <br />
                  A2, 2nd Floor,
                  <br />
                  Palam Dabri Road,
                  <br />
                  Mahavir Enclave Dwarka, New Delhi - 110045
                  <br />
                  Business email: cmsvarshadigitalindia@gmail.com
                </p>

                <p>
                  <strong>A. Dispute Resolution</strong>
                </p>

                <p>
                  This Agreement is governed by applicable laws. Any disputes
                  arising between the parties shall be resolved through good
                  faith discussions before pursuing arbitration or litigation.
                  The parties agree to submit to the jurisdiction of the courts
                  for any unresolved disputes.
                </p>

                <p>
                  <strong>B. Miscellaneous</strong>
                </p>

                <p>
                  These Terms are binding on the parties and their successors.
                  You may not assign these Terms without FTtunes's written
                  consent. FTtunes may freely assign its rights under these
                  Terms. Headings are for reference only and do not affect the
                  interpretation of the Terms.
                </p>

                <p>
                  By continuing to use the FTtunes Site and Services, you agree
                  to these Terms and Conditions.
                </p>

                <div style={{ height: "100px" }} aria-hidden="true" />
              </article>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default TNC;
